import { ComponentProps } from 'react';

export function VisitExpertIcon({ ...props }: ComponentProps<'svg'>) {
    return (
        <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M7.60139 13.5307C7.95602 13.2449 8.39664 13.0892 8.85078 13.0892H15.1492C15.6034 13.0892 16.044 13.2449 16.3986 13.5307L18.3508 15.104H20C21.1046 15.104 22 16.0061 22 17.1189V17.6815C22 18.9824 21.1737 20.1374 19.9487 20.5487L13.2649 22.7932C12.4438 23.0689 11.5562 23.0689 10.7351 22.7932L4.05132 20.5487C2.82629 20.1374 2 18.9824 2 17.6815V17.1189C2 16.0061 2.89543 15.104 4 15.104H5.64922L7.60139 13.5307ZM15.1492 15.104H8.85078L6.89861 16.6774C6.54398 16.9632 6.10336 17.1189 5.64922 17.1189H4V17.6815C4 18.1152 4.27543 18.5001 4.68377 18.6373L11.3675 20.8817C11.7781 21.0196 12.2219 21.0196 12.6325 20.8817L19.3162 18.6373C19.7246 18.5001 20 18.1152 20 17.6815V17.1189H18.3508C17.8966 17.1189 17.456 16.9632 17.1014 16.6774L15.1492 15.104Z'
                fill='currentcolor'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M8 1C6.89543 1 6 1.90208 6 3.01486V6.03716C6 9.37549 8.68629 12.0817 12 12.0817C15.3137 12.0817 18 9.37549 18 6.03716H20C20.5523 6.03716 21 5.58611 21 5.02972C21 4.47334 20.5523 4.02229 20 4.02229H18V3.01486C18 1.90208 17.1046 1 16 1H8ZM16 4.02229V3.01486H8V4.02229H16ZM16 6.03716H8C8 8.26271 9.79086 10.0669 12 10.0669C14.2091 10.0669 16 8.26271 16 6.03716Z'
                fill='currentcolor'
            />
        </svg>
    );
}
